import {Component, Input, OnInit} from '@angular/core';
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {NgForOf, NgIf} from "@angular/common";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {ThemePalette} from "@angular/material/core";
import {Observable} from "rxjs";
import {ApiService, TenantListItem} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-tenant-preview',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    DataPreviewComponent,
    LoaderContainerComponent,
    MatButtonModule,
    MatIconModule,
    NgForOf,
    NgIf,
    RouteContainerComponent,
    DataTableComponent,
    DeleteButtonComponent,
    ManageButtonComponent,
    QuickPreviewPanelComponent
  ],
  templateUrl: './tenant-preview.component.html',
  styleUrl: './tenant-preview.component.sass'
})
export class TenantPreviewComponent implements OnInit {

  @Input() hideActions = false
  @Input() color: ThemePalette

  tenantId?: string
  loader?: Observable<TenantListItem>
  template?: TenantListItem

  constructor(
    readonly api: ApiService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.tenantId = this.activatedRoute.snapshot.params['tenantId']
    this.loader = this.api.getTenant(this.tenantId!)
  }
}
